import { Quaternion, Vector3 } from "three";

/**
 * AxisAngle ist ein alternatives Modell, um eine Orientierung im Raum zu beschreiben.
 * Hierbei wird eine Drehung als eine Drehachse und den Drehwinkel um diese Achse beschrieben.
 * Vorteil gegenüber Quaternion: Speichert auch für sin(angle)=0 die Axis. Die Drehachse geht
 * also nie verloren, im Gegensatz zu einem Quaternion mit Drehwinkel nahe 0.
 * Das ist für bestimmte Situationen, z.B. Kamerafahrten, hilfreich.
 * Mit AxisAngle kann man selbst nicht viel machen, aber zu und von Quaternionen konvertieren.
 */
export class AxisAngle {
  axis: Vector3;
  angle: number;

  /**
   * @param axis Vector
   * @param angle in Bogenmaß
   */
  constructor(axis: Vector3 = new Vector3(0, 0, 0), angle: number = 0) {
    this.axis = axis;
    this.angle = angle;
  }

  /** */
  setFromDegree(x: number, y: number, z: number, angleDegree: number): this {
    this.axis = new Vector3(x, y, z);
    this.angle = (angleDegree * Math.PI) / 180;
    return this;
  }

  /** */
  toQuaternion(): Quaternion {
    return new Quaternion()
      .setFromAxisAngle(new Vector3(0, 0, 1), this.angle)
      .multiply(new Quaternion().setFromUnitVectors(new Vector3(0, 1, 0), this.axis));
  }

  /**
   * @returns {string}
   */
  toString(): string {
    return "(" + this.axis + "," + this.angle + ")";
  }
}
